import React from "react";

export function ProductCatalogActionButton({
  children,
  icon,
  onClick,
  disabled = false,
  variant = "secondary",
  label,
  title,
}) {
  const primary = variant === "primary";
  return (
    <button
      type="button"
      aria-label={label}
      title={title}
      disabled={disabled}
      onClick={onClick}
      className={
        primary
          ? "inline-flex h-10 items-center justify-center gap-2 rounded-md bg-blue-800 px-4 text-sm font-medium text-white hover:bg-blue-900 disabled:cursor-not-allowed disabled:bg-gray-400"
          : "inline-flex h-10 items-center justify-center gap-2 rounded-md border border-zinc-300 bg-white px-4 text-sm font-medium text-zinc-700 hover:bg-zinc-50 disabled:cursor-not-allowed disabled:bg-gray-100"
      }
    >
      {icon && (
        <img
          src={icon}
          alt=""
          className={`h-5 w-5 ${primary ? "brightness-0 invert" : ""}`}
        />
      )}
      <span>{children}</span>
    </button>
  );
}

export function ProductCatalogPage({ title, description, children }) {
  return (
    <main className="mx-auto w-full max-w-screen-2xl px-4 pb-12 sm:px-6">
      <header className="flex flex-wrap items-end justify-between gap-4 border-b border-zinc-200 py-7">
        <div>
          <p className="mb-1 text-sm font-semibold uppercase tracking-[0.14em] text-blue-700">
            Product catalog
          </p>
          <h1 className="text-3xl font-semibold tracking-tight text-zinc-950">
            {title}
          </h1>
          <p className="mt-1 text-sm text-zinc-600">{description}</p>
        </div>
      </header>
      {children}
    </main>
  );
}

export function ProductCatalogToolbar({ children, className = "" }) {
  return (
    <div
      className={`mb-6 flex flex-wrap items-center gap-3 border-b border-zinc-100 py-4 ${className}`}
    >
      {children}
    </div>
  );
}

export function ProductCatalogSectionHeader({
  title = "Catalog records",
  description,
  controls,
}) {
  return (
    <div className="mb-3 flex flex-wrap items-end justify-between gap-3 rounded-lg border border-zinc-200 bg-zinc-50 p-3">
      <div>
        <p className="text-sm font-semibold text-zinc-900">{title}</p>
        {description && (
          <p className="mt-0.5 text-xs text-zinc-600">{description}</p>
        )}
      </div>
      {controls && (
        <div className="flex shrink-0 flex-wrap items-center gap-2">
          {controls}
        </div>
      )}
    </div>
  );
}

export function ProductCatalogTableFrame({ label, children }) {
  return (
    <section aria-label={label}>
      <div className="overflow-x-auto rounded-lg border border-gray-300 bg-white shadow-sm">
        {children}
      </div>
    </section>
  );
}

export const productCatalogTableClassName =
  "min-w-full table-fixed divide-y divide-gray-200 text-left text-sm";

export const productCatalogFlexibleTableClassName =
  "min-w-full table-auto divide-y divide-gray-200 text-left text-sm";
